import { SECONDS_IN_A_DAY } from './constants'

export const snapToGrid = (seconds: number): number => {
    const increment = 15 * 60 // 15 minutes in seconds
    return Math.round(seconds / increment) * increment
}

export const enforceMinimumDuration = (from: number, to: number): number => {
    const minDuration = 30 * 60 // 30 minutes in seconds
    return to - from < minDuration ? from + minDuration : to
}

export const formatTime = (seconds: number): string => {
    const SECONDS_IN_AN_HOUR = 3600
    const SECONDS_IN_A_MINUTE = 60

    // Normalize the seconds to within a day
    const totalSecondsInDay = seconds % SECONDS_IN_A_DAY

    // Calculate hours
    const hours = Math.floor(totalSecondsInDay / SECONDS_IN_AN_HOUR)
        .toString()
        .padStart(2, '0')

    // Calculate minutes
    const minutes = Math.floor((totalSecondsInDay % SECONDS_IN_AN_HOUR) / SECONDS_IN_A_MINUTE)
        .toString()
        .padStart(2, '0')

    return `${hours}:${minutes}`
}
